module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/hero_mob-83795308fbaaf7d6d479f38fe32f12bd.jpg";